<div class="page-header">
  <app-breadcrumb />
  <div class="page-title-row">
    <h1>
      @if (title()) {
        {{ title() }}
      } @else {
        @if (showTitleSkeleton()) {
          <app-skeleton [columns]="3">&nbsp;</app-skeleton>
        }
      }
    </h1>
    <ng-content select="[main-page-actions]"></ng-content>
  </div>
</div>
<div class="page-content">
  <ng-content />
</div>
